module.exports = __webpack_public_path__ + "img/1534035964.6b01b869.jpg";